import React, { useEffect } from "react";
import { getSessionStorage } from "../sessionAndLocalStorage";
import { useNavigate } from "react-router-dom";

// handles users droping into app on a non entry point
export default function ProtectedRoutes({ children }) {
  const appraisalSessionId = getSessionStorage("appraisalSessionId");
  const navigate = useNavigate();

  useEffect(() => {
    if (!appraisalSessionId) {
      navigate("/unauthorised");
    }
  }, [appraisalSessionId]);

  return <>{children}</>;
}
